module.exports = __webpack_public_path__ + "img/preservation.6f36af07.jpg";